<div class="modal-wrapper">
  <div class="modal-header">
    <div class="modal-title">
      <h1 mat-dialog-title>{{data.name}}</h1>
    </div>
  </div>
  <div class="modal-content" mat-dialog-content>
    <div class="items-center">
      <div class="min-w-0">
        <p class="text-sm">
          Click the link below to find details about the support group, including current meeting locations and times.
        </p>
      </div>
    </div>
  </div>
  @if (data.website) {
  <div mat-dialog-actions class="text-center justify-center modal-actions">
    <div style="margin-left: auto; margin-right: auto;">
      <a *ngIf="data.website" [href]="data.website"
        class="items-center shadow-sm p-4 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50">
        <span class="px-2">{{'Visit website'|translate}}</span>
      </a>
    </div>
  </div>
  }

</div>
